// @core/api/endpoints/task/list_time_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTimeEntriesResponse,
} from '../../../types/task';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/task';

/**
 * List time entries
 * Returns all time entries logged against the task, including duration, description, and who logged the time.
 */
export async function ListTimeEntries(
  task_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTimeEntriesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/time`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.get<ListTimeEntriesResponse>(requestPath, { ...requestOptions, params });
}
